import { render, staticRenderFns } from "./LayoutDesigner.vue?vue&type=template&id=5a061ce6&scoped=true"
import script from "./LayoutDesigner.vue?vue&type=script&lang=js"
export * from "./LayoutDesigner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a061ce6",
  null
  
)

export default component.exports